/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('PlanningFormConfigCtrl', [
        "$scope", "$rootScope", "dialog", "dialogsModel", "LanguageManager", "Brand", "OfferManager",
        function($scope,$rootScope,dialog,dialogsModel, LanguageManager, Brand, OfferManager) {
        // hook the passed data to the popin scope
        for (let key in dialogsModel) {
            $scope[key] = dialogsModel[key];
        }

        $scope.brand = Brand;

        //Mock for Oui/Non toggle buttons
        $scope.isEnglishLanguage = function () {
            return LanguageManager.isEnglishLanguage();
        }

        $scope.ad = {
            offerManager: OfferManager
        }

        $scope.dd = {
            verticalZoom : ""+$scope.pTView.config.verticalZoom+"",
            hourDeltaMinute : ""+$scope.pTView.config.hourDeltaMinute+""
        }

        $scope.planningFormConfig = {
            view :
            {
                tab :1,
                mailTab:1,
                vatEditMode : false
            }
        };
        $scope.dialog = dialog;

        $scope.cancel = function(){
            $scope.onClosewindow();
            dialog.close(false);
        };

        $scope.save = function(){
            $scope.onClosewindow();
            dialog.close(true);
        };

        $scope.onClosewindow = function(){
            if(!isNaN($scope.dd.verticalZoom))
                $scope.pTView.config.verticalZoom = parseInt($scope.dd.verticalZoom);
            if(!isNaN($scope.dd.hourDeltaMinute))
                $scope.pTView.config.hourDeltaMinute = parseInt($scope.dd.hourDeltaMinute);
        };
    }]);


// WEBPACK FOOTER //
// ./js/controllers/pro/planningPos/PlanningFormConfigCtrl.js